import { appWithTranslation } from 'next-i18next'
import nextI18nextConfiguration from 'localization/enums/nextI18nextConfiguration'

function withLocalization(App) {
  return appWithTranslation(App, nextI18nextConfiguration)
}

export default withLocalization
